import { useId } from 'react';
import type { SocialId } from '@rabbitfuel/shared';

/**
 * Zeichen der Netzwerke fuers Athleten-Pop-up und die Startliste: ein
 * runder Knopf in der Farbe des Netzwerks, darin ein vereinfachtes weisses
 * Zeichen. Bewusst als eigene SVG statt Schrift oder Fremdbibliothek -- das
 * Bild geht so auch in den RTMP-Ausgang, ohne dass etwas nachgeladen wird.
 */
const COLORS: Record<SocialId, string> = {
  instagram: '#d62976',
  tiktok: '#111111',
  strava: '#fc4c02',
  youtube: '#ff0000',
  facebook: '#1877f2',
  x: '#111111',
  website: '#475569',
};

export function SocialIcon({ id, className }: { id: SocialId; className?: string }) {
  const gradient = `social-ig-${useId().replace(/:/g, '')}`;
  return (
    <svg className={`social-icon${className ? ` ${className}` : ''}`} viewBox="0 0 24 24" aria-hidden>
      {id === 'instagram' && (
        <defs>
          <linearGradient id={gradient} x1="0" y1="1" x2="1" y2="0">
            <stop offset="0" stopColor="#feda75" />
            <stop offset=".35" stopColor="#fa7e1e" />
            <stop offset=".65" stopColor="#d62976" />
            <stop offset="1" stopColor="#4f5bd5" />
          </linearGradient>
        </defs>
      )}
      <circle cx="12" cy="12" r="12" fill={id === 'instagram' ? `url(#${gradient})` : COLORS[id]} />
      <Glyph id={id} />
    </svg>
  );
}

function Glyph({ id }: { id: SocialId }) {
  switch (id) {
    case 'instagram':
      return (
        <g fill="none" stroke="#fff" strokeWidth="1.7">
          <rect x="6" y="6" width="12" height="12" rx="3.6" />
          <circle cx="12" cy="12" r="2.9" />
          <circle cx="15.6" cy="8.4" r=".55" fill="#fff" stroke="none" />
        </g>
      );
    case 'tiktok':
      return (
        <path
          fill="#fff"
          d="M13.3 5.5h2.3a3.4 3.4 0 0 0 3 3v2.3a5.6 5.6 0 0 1-3-1v4.6a4.3 4.3 0 1 1-4.3-4.3h.4v2.4h-.4a1.9 1.9 0 1 0 2 1.9Z"
        />
      );
    case 'strava':
      return (
        <g fill="#fff">
          <path d="M10.6 4.8 6.2 13.4h2.6l1.8-3.5 1.8 3.5H15Z" />
          <path d="m15 13.4-1.3 2.6-1.3-2.6h-2l3.3 6.4 3.3-6.4Z" opacity=".75" />
        </g>
      );
    case 'youtube':
      return <path fill="#fff" d="M9.8 8.2v7.6l6.4-3.8Z" />;
    case 'facebook':
      return (
        <path
          fill="#fff"
          d="M13.2 19v-6.1h2.1l.3-2.5h-2.4V8.9c0-.7.2-1.2 1.2-1.2h1.3V5.5a17 17 0 0 0-1.9-.1c-1.9 0-3.2 1.2-3.2 3.3v1.8H8.5v2.5h2.1V19Z"
        />
      );
    case 'x':
      return (
        <g stroke="#fff" strokeLinecap="round">
          <path d="m7.2 6.6 9.6 10.8" strokeWidth="2.2" />
          <path d="M16.8 6.6 7.2 17.4" strokeWidth="1.3" />
        </g>
      );
    case 'website':
      return (
        <g fill="none" stroke="#fff" strokeWidth="1.4">
          <circle cx="12" cy="12" r="6.5" />
          <ellipse cx="12" cy="12" rx="2.8" ry="6.5" />
          <path d="M5.5 12h13" />
        </g>
      );
    default:
      return null;
  }
}
